/**
 * Shared presentational primitives used by every admin tab component.
 *
 * Extracted from `AdminApp.jsx` (Feb 2026 modularisation pass) so tab
 * components can be lifted into their own files without duplicating
 * these tiny helpers. Keep this file additive — components in here have
 * no state, no side-effects, and no data fetching.
 */
export function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <div>
      <div className="overline mb-2">{eyebrow}</div>
      <h1 className="font-heading font-black text-4xl tracking-tighter mb-2">{title}</h1>
      {subtitle && <p className="text-[#525252] max-w-2xl text-sm">{subtitle}</p>}
    </div>
  );
}

export function Loading() {
  return <div className="text-[#878787] py-20 text-center text-sm">Loading…</div>;
}

export function Err({ msg }) {
  return <div className="text-[#EE2737] py-10 text-sm">{msg}</div>;
}

export function HeatCell({ value }) {
  if (!value) return <span className="text-[#878787]">—</span>;
  const rounded = Math.max(1, Math.min(5, Math.round(value)));
  return (
    <span className={`heatmap-cell heat-${rounded} text-xs !aspect-auto px-3 py-1.5 inline-flex rounded-sm`}>
      {value.toFixed(1)}
    </span>
  );
}

export function KPI({ label, value, icon, accent }) {
  return (
    <div className={`bg-white p-6 ${accent ? "relative" : ""}`}>
      {accent && <div className="absolute top-0 left-0 right-0 h-1 bg-[#EE2737]" />}
      <div className="flex items-center gap-2 text-[#878787]">
        {icon}
        <span className="overline !text-[#878787]">{label}</span>
      </div>
      <div className="font-heading font-black text-4xl mt-2 tracking-tighter">{value}</div>
    </div>
  );
}

export function KpiTile({ label, value, sub, tone }) {
  const style = tone ? { background: tone.bg, color: tone.text, borderColor: tone.border } : {};
  return (
    <div className={`p-3 border ${tone ? "border-l-4" : "border-[#E5E7EB] bg-[#F8F9FA]"}`} style={style}>
      <div className="overline" style={tone ? { color: tone.text } : {}}>{label}</div>
      <div className="font-heading font-black text-2xl mt-1">{value}</div>
      <div className="text-[11px] mt-0.5 opacity-80">{sub}</div>
    </div>
  );
}
